import { useCallback, useState, useEffect } from 'react';

/**
 * Since react-color is controlling the color object and mapping it to valid color object
 * in every change, we wanted to create a local state to let the user insert invalid input
 * and validate it when blurring.
 * @param watchedValue
 * @param onChange
 * @param validationFn
 * @param view
 * @param formatFn
 // * @returns { handleBlur: (...args: any[]) => any,handleChange: (...args: any[]) => any,state: unknown }
 */
export const useColorSync = ({ watchedValue, onChange, validationFn, view, formatFn }) => {
  const [localState, setLocalState] = useState(watchedValue);
  // sync local state with external state when it's updating externally
  useEffect(() => {
    setLocalState(formatFn ? formatFn(watchedValue) : watchedValue);
  }, [formatFn, watchedValue]);

  // update external state by firing onChange ONLY if the inserted value is valid
  const handleChange = useCallback(
    (data) => {
      const validData = validationFn(data);
      if (validData) {
        onChange({ source: view, ...validData });
      }
      setLocalState(data);
    },
    [onChange, validationFn, view]
  );

  // sync with external state to get a validated state
  const handleBlur = useCallback(() => {
    setLocalState(formatFn ? formatFn(watchedValue) : watchedValue);
  }, [formatFn, watchedValue]);

  return {
    localState,
    handleChange,
    handleBlur,
  };
};
